var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-panel"},[_c('div',{class:{ 'overlay': true, 'animated': _vm.animated },on:{"click":_vm.onClose}}),_c('div',{staticClass:"content"},[_c('div',{class:{ 'inner-content': true, 'animated': _vm.animated }},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }